var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8873 37.4201C42.4695 37.0866 43.2072 37.2843 43.5447 37.8642L45.9266 41.132L45.9794 41.1462C46.4275 41.9323 46.1575 42.9401 45.3763 43.3969C44.5949 43.8536 43.5975 43.5863 43.1492 42.8001L41.4013 39.234C41.2272 38.93 41.1816 38.5672 41.2728 38.227C41.364 37.887 41.5847 37.5963 41.8873 37.4201ZM38.4989 16.5528C41.2052 17.2779 43.5092 19.0604 44.9045 21.5074C46.2999 23.9544 46.6727 26.8656 45.9398 29.6009C44.4135 35.2973 38.6071 38.6915 32.9715 37.1815C27.3357 35.6714 24.0045 29.8287 25.5308 24.1324C27.0573 18.4362 32.8633 15.0427 38.4989 16.5528Z",
    fill: "url(#paint0_linear_4293_2334)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4293_2334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2411 21.2479C34.1705 20.4251 31.0072 22.2741 30.1756 25.3777C29.344 28.4813 31.159 31.6643 34.2296 32.4871C37.3002 33.3098 40.4635 31.4608 41.2951 28.3572C41.6945 26.8668 41.4917 25.2805 40.7315 23.9472C39.9712 22.6139 38.7157 21.643 37.2411 21.2479Z",
    fill: "#94D4FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.82515,
    y: -7.90395,
    width: 54.4365,
    height: 63.804
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.49px)",
      clipPath: "url(#bgblur_0_4293_2334_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10.989
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_4293_2334",
    maskUnits: "userSpaceOnUse",
    x: -1.47413,
    y: -1.22474,
    width: 47.7651,
    height: 47.7651,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1.47413,
    y: -1.22474,
    width: 47.7651,
    height: 47.7651
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6122 15.3848C37.3355 6.88803 28.6752 1.826 20.2688 4.07848C16.2319 5.16016 12.7947 7.81843 10.7133 11.4685C8.63186 15.1186 8.07675 19.4615 9.17007 23.5418C11.4468 32.0386 20.1071 37.1006 28.5135 34.8482C36.9199 32.5957 41.8889 23.8817 39.6122 15.3848ZM12.7432 35.8684L9.19046 40.7424L9.11176 40.7635C8.44301 41.9362 8.84573 43.4392 10.0113 44.1204C11.1768 44.8017 12.6638 44.4033 13.3325 43.2305L15.9392 37.9109C16.1989 37.4574 16.2684 36.9172 16.1324 36.4097C15.9964 35.9022 15.6661 35.4692 15.2145 35.2062C14.3461 34.7088 13.2466 35.0034 12.7432 35.8684Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6122 15.3848C37.3355 6.88803 28.6752 1.826 20.2688 4.07848C16.2319 5.16016 12.7947 7.81843 10.7133 11.4685C8.63186 15.1186 8.07675 19.4615 9.17007 23.5418C11.4468 32.0386 20.1071 37.1006 28.5135 34.8482C36.9199 32.5957 41.8889 23.8817 39.6122 15.3848ZM12.7432 35.8684L9.19046 40.7424L9.11176 40.7635C8.44301 41.9362 8.84573 43.4392 10.0113 44.1204C11.1768 44.8017 12.6638 44.4033 13.3325 43.2305L15.9392 37.9109C16.1989 37.4574 16.2684 36.9172 16.1324 36.4097C15.9964 35.9022 15.6661 35.4692 15.2145 35.2062C14.3461 34.7088 13.2466 35.0034 12.7432 35.8684Z",
    fill: "#94D4FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7133 11.4685L11.111 11.6953V11.6953L10.7133 11.4685ZM9.19046 40.7424L9.56047 41.0121C9.49882 41.0966 9.41006 41.1576 9.30897 41.1846L9.19046 40.7424ZM12.7432 35.8684L13.139 36.0987C13.1311 36.1123 13.1225 36.1254 13.1132 36.1381L12.7432 35.8684ZM9.11176 40.7635L8.71401 40.5366C8.77459 40.4304 8.87513 40.3528 8.99325 40.3212L9.11176 40.7635ZM10.0113 44.1204L10.2423 43.7251V43.7251L10.0113 44.1204ZM13.3325 43.2305L13.7437 43.432C13.7395 43.4406 13.735 43.449 13.7303 43.4573L13.3325 43.2305ZM15.9392 37.9109L15.528 37.7094C15.5324 37.7006 15.537 37.6919 15.5418 37.6834L15.9392 37.9109ZM15.2145 35.2062L15.4421 34.8089L15.4449 34.8105L15.2145 35.2062ZM20.2688 4.07848L20.1503 3.6362C28.8054 1.31708 37.7135 6.52973 40.0545 15.2663L39.6122 15.3848L39.17 15.5033C36.9575 7.24632 28.545 2.33491 20.3873 4.52075L20.2688 4.07848ZM10.7133 11.4685L10.3155 11.2417C12.4571 7.48604 15.9946 4.74973 20.1503 3.6362L20.2688 4.07848L20.3873 4.52075C16.4693 5.57059 13.1322 8.15082 11.111 11.6953L10.7133 11.4685ZM9.17007 23.5418L8.7278 23.6603C7.60346 19.4642 8.17402 14.9972 10.3155 11.2417L10.7133 11.4685L11.111 11.6953C9.0897 15.24 8.55005 19.4588 9.61234 23.4233L9.17007 23.5418ZM28.5135 34.8482L28.632 35.2904C19.9769 37.6095 11.0688 32.3969 8.7278 23.6603L9.17007 23.5418L9.61234 23.4233C11.8248 31.6803 20.2373 36.5917 28.395 34.4059L28.5135 34.8482ZM39.6122 15.3848L40.0545 15.2663C42.3955 24.0029 37.2871 32.9713 28.632 35.2904L28.5135 34.8482L28.395 34.4059C36.5527 32.22 41.3824 23.7604 39.17 15.5033L39.6122 15.3848ZM9.19046 40.7424L8.82045 40.4727L12.3732 35.5987L12.7432 35.8684L13.1132 36.1381L9.56047 41.0121L9.19046 40.7424ZM9.11176 40.7635L8.99325 40.3212L9.07195 40.3001L9.19046 40.7424L9.30897 41.1846L9.23026 41.2057L9.11176 40.7635ZM10.0113 44.1204L9.7802 44.5157C8.39801 43.7078 7.92094 41.9274 8.71401 40.5366L9.11176 40.7635L9.50951 40.9903C8.96507 41.945 9.29345 43.1705 10.2423 43.7251L10.0113 44.1204ZM13.3325 43.2305L13.7303 43.4573C12.9353 44.8514 11.1657 45.3256 9.7802 44.5157L10.0113 44.1204L10.2423 43.7251C11.1879 44.2778 12.3922 43.9551 12.9348 43.0037L13.3325 43.2305ZM15.9392 37.9109L16.3504 38.1124L13.7437 43.432L13.3325 43.2305L12.9213 43.029L15.528 37.7094L15.9392 37.9109ZM16.1324 36.4097L16.5747 36.2912C16.7418 36.9147 16.6566 37.5794 16.3366 38.1384L15.9392 37.9109L15.5418 37.6834C15.7411 37.3354 15.795 36.9197 15.6901 36.5282L16.1324 36.4097ZM15.2145 35.2062L15.4449 34.8105C16.0016 35.1346 16.4076 35.6677 16.5747 36.2912L16.1324 36.4097L15.6901 36.5282C15.5852 36.1368 15.3307 35.8037 14.9841 35.6019L15.2145 35.2062ZM12.7432 35.8684L12.3475 35.6381C12.9774 34.5556 14.3553 34.1864 15.4421 34.8089L15.2145 35.2062L14.9869 35.6035C14.3368 35.2312 13.5158 35.4512 13.139 36.0987L12.7432 35.8684Z",
    fill: "url(#paint1_linear_4293_2334)",
    mask: "url(#path-3-outside-1_4293_2334)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4293_2334",
    x: 23.1057,
    y: 14.1842,
    width: 25.2578,
    height: 25.3665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.43405,
    result: "effect1_foregroundBlur_4293_2334"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4293_2334_clip_path",
    transform: "translate(2.82515 7.90395)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6122 15.3848C37.3355 6.88803 28.6752 1.826 20.2688 4.07848C16.2319 5.16016 12.7947 7.81843 10.7133 11.4685C8.63186 15.1186 8.07675 19.4615 9.17007 23.5418C11.4468 32.0386 20.1071 37.1006 28.5135 34.8482C36.9199 32.5957 41.8889 23.8817 39.6122 15.3848ZM12.7432 35.8684L9.19046 40.7424L9.11176 40.7635C8.44301 41.9362 8.84573 43.4392 10.0113 44.1204C11.1768 44.8017 12.6638 44.4033 13.3325 43.2305L15.9392 37.9109C16.1989 37.4574 16.2684 36.9172 16.1324 36.4097C15.9964 35.9022 15.6661 35.4692 15.2145 35.2062C14.3461 34.7088 13.2466 35.0034 12.7432 35.8684Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4293_2334",
    x1: 52.1846,
    y1: 20.2198,
    x2: 20.3836,
    y2: 34.4344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4293_2334",
    x1: 30.9484,
    y1: 5.64844,
    x2: 8.93378,
    y2: 42.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24);
export default __webpack_public_path__ + "static/media/icon24.f3b4b409197270d137e0062b642fe747.svg";
export { ForwardRef as ReactComponent };